import { useTranslation } from '@wix/wix-i18n-config';
import { Sound, SoundOff, SoundOffSmall,SoundSmall } from '@wix/wix-ui-icons-common';
import { Sound as SoundEditor3, SoundSmall as SoundSmallEditor3 } from '@wix/wix-ui-icons-common/odeditor';
import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { chatActions } from '../../../common/reducers/chat';
import { selectIsMuted } from '../../../common/selectors/chat';
import { cookie } from '../../../util/cookie';
import { renderModel } from '../../../util/renderModel';
import { HeaderActionsIcon } from '../HeaderActions/HeaderActionsIcon';
import { headerFullPageDataHooks } from '../HeaderFullPage/HeaderFullPage.dataHooks';

const cookieName = 'isMuted';

const isCopilot = renderModel.isCopilot();
const isEditor3 = renderModel.isEditor3();

export const MuteButton: FC = () => {
  const { t } = useTranslation();
  const isMuted = useSelector(selectIsMuted);
  const tooltipContent = isMuted ? 'header_action_icon_unmute' : 'header_action_icon_mute';
  const dispatch = useDispatch();

  const onToggleMute = useCallback(() => {
    const mute = !isMuted;

    dispatch(chatActions.toggleMute(mute));
    cookie.set(cookieName, mute);
  }, [isMuted, dispatch]);

  if (isCopilot) {
    return <>{isMuted ? <SoundOffSmall onClick={onToggleMute} /> : <SoundSmall onClick={onToggleMute} />}</>;
  }

  return (
    <HeaderActionsIcon
      onClick={onToggleMute}
      dataHook={headerFullPageDataHooks.toggleMute()}
      tooltipContent={t(tooltipContent)}
    >
      {isMuted ? <SoundOff /> : isEditor3 ? <SoundSmallEditor3 /> : <Sound />}
    </HeaderActionsIcon>
  );
};
